import { ReactNode } from 'react';
import styles from './LoadingSpinner.module.scss';

export type Props = Readonly<{
    children: JSX.Element;
    isLoading: boolean;
    marginTop?: string;
    loadingMessage?: ReactNode;
}>;

const LoadingSpinner = ({ marginTop, isLoading, children, loadingMessage }: Props): JSX.Element => {
    return isLoading ? (
        <div className={styles['lds-roller-container']} style={{ marginTop }}>
            <div className={styles['lds-roller']}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            {loadingMessage && <div className={styles['lds-roller-message']}>{loadingMessage}</div>}
        </div>
    ) : (
        <div className={styles['lds-fade-in']}>{children}</div>
    );
};

export default LoadingSpinner;
